/**
 * Contexte d'inclusion du composant des indemnités
 */
export enum Contexte {
    FRAIS,
    ENGAGEMENTS
}